import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/Table";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import ReserveTenantTable from "../../Components/Tenants/ReserveTenantTable";
import { toast } from "react-toastify";
import CancelReservation from "../../Components/Tenants/Details/CancelReservation";
import MoveInManually from "../../Components/Tenants/Details/MoveInManually";
import SideModal from "../../Components/SideModal";
import MoveInReschedule from "../../Components/Tenants/Details/MoveInReschedule";
import ViewReserveModal from "../../Components/Tenants/Details/ViewReserveModal";
import MoveOutPendingTenantTable from "../../Components/Tenants/MoveOutPendingTenantTable";
import CancelEviction from "../../Components/Tenants/Details/CancelEviction";
import EvictNowModal from "../../Components/Tenants/Details/EvictNowModal";
import ExtendStay from "../../Components/Tenants/Details/ExtendStay";
import ViewMoveOutPendingTenantDetail from "../../Components/Tenants/Details/ViewMoveOutPendingTenantDetail";

const MoveOutPendingTenantListing = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const [isFocused, setIsFocused] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState();
    const [selectedProperty, setSelectedProperty] = useState(property);
    const [isCancelEviction, setIsCancelEviction] = useState(false);
    const [isMoveIn, setIsMoveIn] = useState(false);
    const [isMoveInReschedule, setIsMoveInReschedule] = useState(false);
    const [viewDetail, setViewDetail] = useState(false);
    const [isEvictNow, setIsEvictNow] = useState(false);
    const [isExtendStay, setIsExtendStay] = useState(false);
    // const query = `propId=${selectedProperty?.id}&searchVal=&filter=R`;
    const query = `&searchVal=&filter=MOP&propId=${selectedProperty?.id === 0 ? null : selectedProperty?.id
        }`;
    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/tenant/list/new?${query}`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setApiData(res?.data?.list);
            setIsFocused(true);
        }
    };

    const getError = () => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);
        return () => clearTimeout(handler);
    }, [selectedProperty]);

    //------- Cancel Eviction Model -------
    const CancelEvictionFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/client/tenant/remove/cancel`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const cancelEvictionSuccess = (data) => {
        getListMutate()
        setIsCancelEviction(false);
        toast.success(data?.data?.msg || "Success");
    };

    const cancelEvictionError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading: cancelEvictionLoading,
        mutate: cancelEvictionMutate,
    } = useMutation(CancelEvictionFunction, {
        onSuccess: cancelEvictionSuccess,
        onError: cancelEvictionError,
    });

    //------- Evict Now Model -------
    const evictNowFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/client/tenant/remove/now`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const evictNowSuccess = (data) => {
        setIsEvictNow(false)
        getListMutate()
        toast.success(data?.data?.msg || "Success");
    };

    const evictNowError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: evictNowLoading, mutate: evictNowMutate } = useMutation(
        evictNowFunction,
        {
            onSuccess: evictNowSuccess,
            onError: evictNowError,
        }
    );

    //------- Extend Stay Model -------
    const ExtendStayFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/client/tenant/extend/stay`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const extendStaySuccess = (data) => {
        getListMutate();
        setIsExtendStay(false);
        toast.success(data?.data?.msg || "Success");
    };

    const extendStayError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: extendStayLoading, mutate: extendStayMutate } =
        useMutation(ExtendStayFunction, {
            onSuccess: extendStaySuccess,
            onError: extendStayError,
        });
    const handleExtendStayClose = () => {
        setIsExtendStay(false);
    };

    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Move-Out Pending"}
                        <Underline />
                    </BoxTitle>
                </BoxHead>

                {!error && !isLoading && apiData && (
                    // <FilterTableWrapper>
                    <TableWrapper>
                        <MoveOutPendingTenantTable
                            apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            userType={user.userType}
                            setIsCancelEviction={setIsCancelEviction}
                            setIsEvictNow={setIsEvictNow}
                            setIsExtendStay={setIsExtendStay}
                            setViewDetail={setViewDetail}
                        />
                        {(error || apiData?.length == 0) && !isLoading && (
                            <NotFoundModel />
                        )}
                    </TableWrapper>
                    // </FilterTableWrapper>
                )}
                {(isLoading || isRefetching) && <Loading />}
                {error && !isLoading && <NotFoundModel />}
                {isCancelEviction && (
                    <CancelEviction
                        setIsCancelEviction={setIsCancelEviction}
                        cancelEvictionLoading={cancelEvictionLoading}
                        cancelEvictionMutate={cancelEvictionMutate}
                        selectedData={selectedData}
                    />
                )}
                {isEvictNow && (
                    <EvictNowModal
                        setIsEvictNow={setIsEvictNow}
                        evictNowLoading={evictNowLoading}
                        evictNowMutate={evictNowMutate}
                        selectedData={selectedData}
                    />
                )}
                <SideModal
                    isOpen={isExtendStay}
                    onClose={() => setIsExtendStay(false)}
                >
                    <ExtendStay
                        setIsExtendStay={setIsExtendStay}
                        selectedData={selectedData}
                        extendStayLoading={extendStayLoading}
                        extendStayMutate={extendStayMutate}
                        handleClose={handleExtendStayClose}
                    />
                </SideModal>
                <SideModal
                    isOpen={viewDetail}
                    onClose={() => setViewDetail(false)}
                >
                    <ViewMoveOutPendingTenantDetail
                        setViewDetail={setViewDetail}
                        viewDetail={viewDetail}
                        selectedData={selectedData}
                    />
                </SideModal>
            </BoxContainer>
        </>
    );
};

const TableWrapper = tw.h1`my-8 border bg-white rounded-md `;

export default MoveOutPendingTenantListing;
